import { Stack, Typography } from "@mui/material";
import { useShow } from "@refinedev/core";
import { Show, TextFieldComponent as TextField } from "@refinedev/mui";

const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

export const FeatureFlagShow = () => {
  const { query } = useShow({});
  const { data, isLoading } = query;

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          {"ID"}
        </Typography>
        <TextField value={record?.id} />

        <Typography variant="body1" fontWeight="bold">
          {"Key"}
        </Typography>
        <TextField value={record?.key} />

        <Typography variant="body1" fontWeight="bold">
          {"Rollout Percentage"}
        </Typography>
        <TextField value={record?.percentage != null ? `${record.percentage}%` : "-"} />

        <Typography variant="body1" fontWeight="bold">
          {"Description"}
        </Typography>
        <TextField value={record?.description ?? "-"} />

        <Typography variant="body1" fontWeight="bold">
          {"Created At"}
        </Typography>
        <TextField value={formatDateTime(record?.createdAt)} />

        <Typography variant="body1" fontWeight="bold">
          {"Updated At"}
        </Typography>
        <TextField value={formatDateTime(record?.updatedAt)} />
      </Stack>
    </Show>
  );
};
